import styled from "@emotion/styled";

import { DesignToken } from "@livechat/design-system-react-components";

import { withVar } from "themes/helpers";

export const StyledWrapper = styled.div`
  max-width: 880px;
  width: 100%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: ${withVar(DesignToken.SurfacePrimaryDefault)};

  > div {
    width: 100%;
  }
`;
